// Import
import $ixios from '../shared/ixios-instance.js'


export default {
  /* *****************************************************************************************************
  * State
  */
  state: {
    rootView: {}
  },
  /* *****************************************************************************************************
  * Mutations
  * list of mutations
  */
  mutations: {
    /* ***********************************************************
    * Set case
    * active the application using the information after login
    */
    documentview (state, content) {
      $ixios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    }
  },
  /*****************************************************************************
  * Actions
  *
  */
  actions: {
    /* ***********************************************************
    * Document view
    */
    documentview ({ commit }, payload) {
      commit('documentview', payload)
      return new Promise((resolve, reject) => {
        $ixios.get('documentlibrary/view/' + payload.id, {params: payload})
          .then(response => {
            //
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchFileAsBlob({ commit }, url) {
      // //TODO (Marta): Remove the hardcoded file
      // url = 'https://images.pexels.com/photos/2118174/pexels-photo-2118174.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260';
      return fetch(url).then(res => {
        return res.blob();
      });
    }
  }
}
